<template>
    <div class="post-comments">
        <template v-if="initial_load_complete">
            <template v-if="topic.permissions.includes('READ')">
                <div class="card-inner"
                     :class="{'no-padding-bottom' : viewType === 'moodview'}">
                    <div class="card-comments">
                        <div class="load-more comments extra-light-text hover-opacity no-select tiny-text"
                             v-if="!singleTopic && total_comments > commentsLength"
                             @click="loadComments(true)"
                             :class="{'paginating': currently_paginating}">
                            <i class="far fa-chevron-double-up inline" style="padding-right: 5px;"></i>
                            <p class="inline">{{ total_comments - commentsLength }} {{ translations['forum.earlier_comments'] }}</p>
                        </div>

                        <transition-group name="simple-conversation-fade">
                            <comment v-for="comment in orderedComments"
                                     :viewType="viewType"
                                     :focusCommentByHashId="focusCommentByHashId"
                                     :singleTopic="singleTopic"
                                     :key="comment.id"
                                     :topic="topic"
                                     :comment="comment"></comment>
                        </transition-group>

                        <template v-if="user && !topic.closed && topic.permissions.includes('REPLY')">
                            <div class="comment-wrapper new-comment flex">
                                <div class="flex-1 flex-no-padding">
                                    <div class="profile-icon-l relative">
                                        <template v-if="user.active_trophy">
                                            <template v-if="user.active_trophy.icon">
                                                <trophy :trophy="user.active_trophy"
                                                        :showTitle="false"
                                                        :showDesc="false"
                                                        :size="20"
                                                        :displayOnFeed="true"
                                                        orientation="horizontal">
                                                </trophy>
                                            </template>
                                        </template>
                                        <a :href="'/profile/' + user.username">
                                            <img :src="user.avatar" onerror="this.src='/img/avatar.png'"/>
                                        </a>
                                    </div>
                                </div>
                                <div class="flex-16 flex-no-padding comment-content relative">
                                    <div class="post-new-comment tw-h-full">
                                        <div class="new-comment tw-h-full">
                                            <template v-if="!user.impersonating">
                                                <huddle-editor-v2 v-model="new_comment"
                                                                  :submit_on_enter="true"
                                                                  :mentions="true"
                                                                  :emojis="true"
                                                                  :gifs="true"
                                                                  :images="true"
                                                                  :customData="{topic: topic, user: user}"
                                                                  :placeholder="this.translations['social.add_comment']"
                                                                  :mobile_send_btn="true"
                                                                  :submittable="true"
                                                                  @submit="submitNewComment">
                                                </huddle-editor-v2>
                                            </template>
                                            <div v-else class="tw-flex tw-items-center tw-h-full light-text">
                                                <i class="far fa-lock tw-pr-2"></i>
                                                <p>{{ translations['admin.cant_comment__while_impersonating'] }} {{ user.username }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="!user">
                            <login-to-comment></login-to-comment>
                        </template>
                        <!-- end status == open check -->
                    </div>
                    <template v-if="topic.closed">
                        <div class="post-closed-message normal-text">
                            <i class="far fa-lock"></i>
                            <h3>{{ translations['forum.topic_closed'] }}</h3>
                        </div>
                    </template>
                </div>
            </template>
            <template v-else-if="!user && !topic.closed">
                <div class="card-inner" :class="{'no-padding-bottom' : viewType === 'moodview'}">
                    <div class="card-comments">
                        <login-to-comment></login-to-comment>
                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
    import Global from '../../mixins/Global.js'
    import axios from 'axios'
    import orderBy from 'lodash.orderby';
    import {mapState, mapMutations} from 'vuex';
    import LoginToComment from './LoginToComment';

    export default {
        mixins: [Global],

        components: {
          'login-to-comment': LoginToComment,
        },

        props: {
            topic: {
                required: true
            },
            viewType: {},
            singleTopic: {
                default: false
            },
            focusCommentByHashId: false,
        },

        data() {
            return {
                failed: false,
                pagination: false,
                total_comments: false,
                currently_paginating: false,
                initial_load_complete: false,
                new_comment: '',
                editor: false,
            }
        },

        computed: {
            ...mapState([
                'comment_load_timeout', 'appear_logged_in'
            ]),

            orderedComments() {
                let comments = orderBy(this.topic.comments(), 'created_at', 'asc');

                if(this.topic.answered) {
                    comments = orderBy(comments, 'accepted_answer', 'desc');
                }

                return comments;
            },

            commentsLength() {
                return this.topic.comments().length;
            },
        },

        methods: {
            ...mapMutations([
                'increaseCommentTimeout',
                'decreaseCommentTimeout'
            ]),

            submitNewComment(payload) {
                // if content is present then it is a normal text submit
                if(typeof payload.content !== 'undefined') {
                    if (payload.content !== '') {
                        let data = {
                            'content': payload.content,
                            'upload_uuids': payload.imagesUUIDs
                        };

                        this.$store.dispatch(
                            {
                                type: 'submitComment',
                                data: {
                                    payload: payload,
                                    id: this.topic.id,
                                    data: data,
                                    success_callback: function (response) {
                                        success_callback();
                                    }
                                }
                            }
                        );
                    }
                } else {
                    // else it's a GIF
                    let data = {
                        'content': '<img src="' + payload.gif + '">',
                        'upload_uuids': []
                    };

                    this.$store.dispatch(
                        {
                            type: 'submitComment',
                            data: {
                                payload: payload,
                                id: this.topic.id,
                                data: data,
                                success_callback: function (response) {
                                    success_callback();
                                }
                            }
                        }
                    );
                }

                let success_callback = function () {

                };
            },

            loadComments(paginate = true) {
                if(!this.currently_paginating) {
                    this.currently_paginating = true;

                    let url = `/api/v3/topics/${this.topic.id}/comments` ;

                    let params = new URLSearchParams();

                    // params.append('topic_id', this.topic.id);
                    //params.append('skipComments', true);

                    params.append('page', this.pagination ? this.pagination.current_page+1 : 1);

                    if(paginate) {
                        params.append('size', 10);
                    }

                    let request = {
                        params: params
                    };

                    axios.get(url, request)
                        .then((response) => {
                            //comments data
                            let comments = response.data;

                            //if this is the first pagination after the initiload load, remove the first 3 comments as we already have them stored
                            if(paginate && response.data.meta.current_page === 1 && this.initial_load_complete) {
                                comments.data.splice(0, 5);
                            }

                            //filter the keys of the object we receive so we ensure that they new comments we add start at key 0
                            if(typeof comments.data === 'object') {
                                let filtered_comments = [];

                                for (let i in comments.data) {
                                    filtered_comments.push(comments.data[i]);
                                }

                                comments.data = filtered_comments;
                            }

                            let data_models = [
                                {
                                    model: 'Comment',
                                    source: 'data',
                                    nested_models: [
                                        {
                                            model: 'Like',
                                            source: 'liked_by',
                                            storage: 'likes',
                                            parent_key: 'comment_id',
                                        },
                                        {
                                            model: 'Reply',
                                            source: 'replies',
                                            storage: 'replies',
                                            parent_key: 'comment_id',
                                            nested_models: [
                                                {
                                                  model: 'User',
                                                  source: 'user',
                                                  storage: 'users',
                                                  child_key: 'user_id'
                                                }
                                            ],
                                        },
                                        {
                                          model: 'User',
                                          source: 'user',
                                          storage: 'users',
                                          child_key: 'user_id'
                                        },
                                    ],
                                },
                            ];

                            ActiveDataStore.activeDataSetup(data_models, comments);

                            //always save total amount of items so we can see if pagination is needed/possible
                            if(response.data.meta) {
                                this.total_comments = response.data.meta.total;

                                //only add pagination data when we are paginating and not on the initial load
                                if(paginate) {
                                    this.pagination = response.data.meta;
                                }
                            }

                            this.currently_paginating = false;
                            this.failed = true;
                            this.initial_load_complete = true;
                        }, error => {
                            this.failed = true;
                            this.currently_paginating = false;
                        });
                }
            },
        },

        mounted() {
            //the comments length check refrains a moodpost from loading its comments every time it is opened
            if(!this.singleTopic && this.topic.comments().length === 0) {
                this.increaseCommentTimeout();

                setTimeout(() => {
                    this.decreaseCommentTimeout();
                    this.loadComments(true);
                }, this.comment_load_timeout);
            } else {
                this.initial_load_complete = true;
            }
        }
    }
</script>